import topTitle from '@/components/title.vue';
import { personnelDetailsRecordDetail1 } from '../customerManage/request';
import { personnelDetailsRecordDetail } from './request';
export default {
  components: {
    topTitle
  },
  props: ['visible', 'policyId', 'personnelDetailsId'],
  watch: {
    async visible(newV) {
      if (newV) {
        await this.getInfo({
          policyId: this.policyId,
          personnelDetailsId: this.personnelDetailsId
        });
      }
      this.showVisible = newV;
    }
  },
  data() {
    return {
      showVisible: false,
      insuranceInfo: [{
        name: '保单号',
        key: 'policyNo'
      }, {
        name: '保险方案',
        key: 'insurancePlanName'
      }, {
        name: '保险起期',
        key: 'startAt'
      }, {
        name: '保险止期',
        key: 'endAt'
      }, {
        name: '保险名称',
        key: 'insuranceName'
      }, {
        name: '保险状态',
        key: 'policyStatus'
      }],
      insureInfo: [{
        name: '工种序号',
        key: 'jobNumber'
      }, {
        name: '工种',
        key: 'occupation'
      }, {
        name: '证件类型',
        key: 'identificationType'
      }, {
        name: '证件号码',
        key: 'idNumber'
      }, {
        name: '姓名',
        key: 'name'
      }, {
        name: '投保时间',
        key: 'createAt'
      }, {
        name: '保费',
        key: 'premium'
      }, {
        name: '责任起期',
        key: 'startAt'
      }],
      cancellationInfo: [{
        name: '已退保费',
        key: 'rePremium'
      }, {
        name: '退保时间',
        key: 'refundAt'
      }, {
        name: '责任止期',
        key: 'endAt'
      }, {
        name: '操作人',
        key: 'operator'
      }],
      insuranceInfoData: {},
      insureInfoData: {},
      cancellationInfoData: {},
      idParams: {}
    };
  },
  methods: {
    async getInfo(obj) {
      let request = this.$store.state.user.accountInfo.customerId === 0 ? personnelDetailsRecordDetail : personnelDetailsRecordDetail1;
      const res = await request(obj);
      this.insuranceInfoData = res.insuranceInfo;
      this.insureInfoData = res.insuredInfo;
      this.cancellationInfoData = res.canceledInfo;
    }
  }
};